import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PianoTuningDetailContainerStyled } from "./styled";
import { useTranslation } from "react-i18next";
import { userService } from "apiServices";
import { MemberSwitchTypeWidget } from "widgets";
import { Buttons, Cards, Displays } from "components";

const PianoTuningDetailContainer = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { t, i18n } = useTranslation(["history"]);

  const [_isLoading, _setIsLoading] = useState(true);
  const [_data, _setData] = useState(null);

  useEffect(() => {
    _fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const _fetchData = async () => {
    let resArr = await Promise.all([
      userService.GET_MY_PRODUCT_WARRANTEE_DETAIL(id),
      userService.GET_MY_INSTRUMENT_DETAIL(id, "1"),
    ]);
    if (resArr) {
      const reduce = resArr[1].data.reduce(
        (result, data) => {
          if (data.status !== "1") {
            result.maintenanceInstrumentList.push(data);
          }
          if (data.status === "1") {
            result.maintenanceInstrumentLatest = data;
          }
          return result;
        },
        {
          maintenanceInstrumentList: [],
          maintenanceInstrumentLatest: false,
        }
      );
      let resReward = reduce.maintenanceInstrumentLatest
        ?.reward_e_voucher_ref_id
        ? await userService.GET_REWARD_E_VOUCHER_DETAIL(
            reduce.maintenanceInstrumentLatest.reward_e_voucher_ref_id
          )
        : { data: false };
      if (resReward) {
        _setData({
          productWarrantyDetail: resArr[0].data,
          maintenanceInstrumentList: reduce.maintenanceInstrumentList,
          maintenanceInstrumentLatestDetail: reduce.maintenanceInstrumentLatest,
          promotionDetail: resReward.data,
        });
        _setIsLoading(false);
      }
    }
  };

  return (
    <PianoTuningDetailContainerStyled>
      <div className="member_type_layout">
        <MemberSwitchTypeWidget type="4" />
      </div>
      {_isLoading ? (
        <Displays.Loading />
      ) : (
        <>
          <div className="title_label">
            {i18n.language === "en"
              ? "Musical instrument details"
              : "รายละเอียดเครื่องดนตรี"}
          </div>
          <div className="product_info_layout">
            <Cards.ProductWarrantee
              titleShow
              title={
                _data.productWarrantyDetail.pd_dep_desc +
                " " +
                _data.productWarrantyDetail.pd_cat02_desc +
                " " +
                _data.productWarrantyDetail.pd_cat03_desc
              }
              description={_data.productWarrantyDetail.description}
              descriptionLine2={_data.productWarrantyDetail.description_line_2}
              sn={_data.productWarrantyDetail.serial_no}
              itemNo={_data.productWarrantyDetail.item_no}
              warrantyPeriod={_data.productWarrantyDetail.warranty_period}
              warrantyUnit={_data.productWarrantyDetail.warranty_unit}
              warrantyDescription={
                _data.productWarrantyDetail.warranty_description_th
              }
              rejectedReason={_data.productWarrantyDetail.rejected_reason}
              status={_data.productWarrantyDetail.status}
              approvedWarrantyDate={
                _data.productWarrantyDetail.approved_warranty_date
              }
              extensionPeriod={_data.productWarrantyDetail.extension_period}
              extensionUnit={_data.productWarrantyDetail.extension_unit}
              customer_note={_data.productWarrantyDetail.customer_note}
            />
          </div>
          {_data.maintenanceInstrumentLatestDetail && (
            <div className="booking_layout">
              <Cards.MyInstumentTuneBooking
                {..._data.maintenanceInstrumentLatestDetail}
              />
            </div>
          )}
          {_data.promotionDetail && (
            <Cards.PromotionPackage {..._data.promotionDetail} />
          )}
          {_data.maintenanceInstrumentList && (
            <Cards.InstumentTune data={_data.maintenanceInstrumentList} />
          )}
          <div className="btn_wrap">
            <Buttons.BgStandard
              label={t("Back", { ns: "common" })}
              onClick={() => navigate(-1)}
            />
          </div>
        </>
      )}
    </PianoTuningDetailContainerStyled>
  );
};

export default PianoTuningDetailContainer;
